import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function VisionMission() { 
  useEffect(() => {
    document.title = 'Vision & Mission -  CARMEL CONVENT SCHOOL, DHARUHERA';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>About Us</li>
                <li>Vision & Mission</li> 
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Vision & Mission</h2>
            </div>
          </div> 
          <div className="row">
                <div className="col-12">
                <h5>Vision</h5>
                     <p><b>“Excelling in Knowledge, Character, and Environmental Stewardship.”</b></p>
                     <p>Carmel Convent School, Dharuhera, envisions nurturing students to rise in wisdom and faith while shining as compassionate leaders and responsible stewards of creation. Rooted in the Carmelite spirit, the school fosters academic excellence, moral integrity, and environmental consciousness to shape future-ready individuals.</p>
                  <h5>Mission:</h5>
                  <p>To achieve this vision, Carmel Convent School is committed to:</p>

                     <ul className="mainlist">
                        <li>  Academic Excellence – Cultivating curiosity, critical thinking, and lifelong learning. </li>
                        <li>  Character Formation – Instilling integrity, humility, and a spirit of service. </li>
                        <li>  Environmental Stewardship – Promoting sustainable practices and care for creation. </li>
                        <li>  Leadership & Social Responsibility – Developing confident, compassionate changemakers. </li>
                        <li> Faith and Holistic Growth – Strengthening moral and spiritual foundations for a balanced life. </li>
                     </ul>
                  <p>Guided by the motto “Rise in Faith, Shine in Deeds, and Care for Creation,” the school empowers students to excel, serve, and protect the world.</p>

                   
               </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default VisionMission;
